define('RecentlyViewedItems.View.Extension', [
  'RecentlyViewedItems.View',
  'RecentlyViewedItems.Collection',
  'underscore',
  'Utils'
], function (View, RecentlyViewedItemsCollection, _, Utils) {
  'use strict';

  return _.extend(View.prototype, {
    initialize: _.wrap(View.prototype.initialize, function (fn) {
      var result = fn.apply(this, _.toArray(arguments).slice(1));
      var layout = this.options.application.getLayout();

      layout && layout.on('afterAppendView', this.loadRecentlyViewedItem, this);

      return result;
    }),

    loadRecentlyViewedItem: function loadRecentlyViewedItem() {
      var self = this;

      RecentlyViewedItemsCollection.getInstance().turnOnTracking();

      this.collection.promise &&
        this.collection.promise.done(function () {
          var number_of_items_displayed =
            SC.CONFIGURATION.recentlyViewedItems.numberOfItemsDisplayed;
          self.collection = self.collection.first(parseInt(number_of_items_displayed));

          self.render();

          var carousel = self.$el.find('[data-type="carousel-items"]');

          if (Utils.isPhoneDevice() === false && SC.CONFIGURATION.siteSettings.imagesizes) {
            var thumbnail = _.where(SC.CONFIGURATION.siteSettings.imagesizes, {
              name: SC.CONFIGURATION.imageSizeMapping.thumbnail
            })[0];
            var img_min_height = thumbnail.maxheight;

            carousel
              .find('.item-relations-related-item-thumbnail')
              .css('minHeight', img_min_height);
          }

          Utils.initBxSlider(carousel, SC.CONFIGURATION.bxSliderDefaults);
        });
    }
  });
});
